import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Zap } from "lucide-react";

export default function MyBriefs() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/briefs/mine").then(({ data }) => setItems(data.items || []));
  }, []);

  return (
    <div className="mx-auto max-w-7xl px-6 lg:px-10 py-10">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <div className="overline text-safety">Your requests</div>
          <h1 className="mt-2 font-display font-black text-4xl tracking-tighter text-forest">My clearance requests</h1>
        </div>
        <Button asChild className="rounded-none bg-forest hover:bg-forest-800 text-white h-11 px-6" data-testid="mybriefs-new">
          <Link to="/briefs/new">Post a request</Link>
        </Button>
      </div>

      {items.length === 0 ? (
        <div className="mt-10 border border-border bg-white p-16 text-center">
          <div className="font-display text-2xl tracking-tight text-forest">No clearance requests yet</div>
          <p className="mt-2 text-sm text-muted-foreground">Post one and start receiving quotes from UK removal firms.</p>
          <Button asChild className="mt-6 rounded-none bg-safety hover:bg-safety-hover text-white h-11 px-6" data-testid="mybriefs-empty-cta">
            <Link to="/briefs/new">Post a request →</Link>
          </Button>
        </div>
      ) : (
        <div className="mt-8 border border-border bg-white">
          {items.map((b, i) => (
            <div key={b.brief_id} className={`p-5 ${i > 0 ? "border-t border-border" : ""} hover:bg-sage-light transition-colors duration-200`}>
              <div className="flex flex-wrap items-center gap-2 mb-1">
                <Badge className="rounded-none bg-forest text-white overline">{b.status}</Badge>
                {b.is_featured && (
                  <Badge className="rounded-none bg-safety text-white overline inline-flex items-center gap-1">
                    <Zap className="w-3 h-3" /> Boosted
                  </Badge>
                )}
                <span className="overline text-[10px] text-muted-foreground">{new Date(b.created_at).toLocaleDateString("en-GB")}</span>
              </div>
              <div className="flex flex-wrap items-start justify-between gap-3">
                <Link to={`/briefs/${b.brief_id}`} data-testid={`mybrief-row-${b.brief_id}`} className="flex-1 min-w-0">
                  <div className="font-display text-lg tracking-tight hover:text-forest">{b.title}</div>
                  <div className="mt-1 flex flex-wrap gap-4 text-xs text-muted-foreground">
                    <span>{b.location}</span>
                    <span>{b.approx_items}</span>
                    <span className="text-safety overline">{b.quote_count} quote{b.quote_count === 1 ? "" : "s"}</span>
                  </div>
                </Link>
                {b.status === "open" && !b.is_featured && (
                  <Button asChild size="sm" className="rounded-none bg-safety hover:bg-safety-hover text-white h-9 px-4 shrink-0" data-testid={`mybrief-boost-${b.brief_id}`}>
                    <Link to={`/briefs/${b.brief_id}/boost`}><Zap className="w-3.5 h-3.5 mr-1" /> Boost</Link>
                  </Button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
